import React from 'react'
import {selectGlobalDataState} from '../../../../../../features/global/globalDataSlice'
import {selectMyContractsState, changeConfirmationDialogState, setCurrentAction} from '../../../../../../features/myContracts/myContractsSlice'
import {sendGeneralRequest} from '../../../../../../features/generalRequest'
import ConfirmationDialog from '../../../../../general/ConfirmationDialog'
import * as yup from 'yup'
import { useSelector, useDispatch } from 'react-redux';
import { texts } from '../../../../../general/texts'


const validationSchema = yup.object({
    contract: yup
      .string('Enter contract number')
      .required('Contract number is required'),
    description: yup
      .string('Enter contract name')
      .required('Contract name is required'),
  });      
  
const DeleteContract = (props) => {

    const dispatch = useDispatch()
    const myContractsSliceState = useSelector(selectMyContractsState)
    const globalDataSliceState = useSelector(selectGlobalDataState)

    const handleConfirmation = () => 
    {
        dispatch(sendGeneralRequest(
            {request: {token: globalDataSliceState.token, contract: myContractsSliceState.contractToDelete.contract, optional:myContractsSliceState.contractToDelete.optional, description: myContractsSliceState.contractToDelete.description, service: myContractsSliceState.contractToDelete.service},
            baseUrlKey:'services',
            endpoint:'InactivateContract'}))
        dispatch(setCurrentAction(''))
    }

    const handleClose = () => 
    {
        dispatch(setCurrentAction(''))
    }

  return (
    <ConfirmationDialog handleClose={handleClose} isConfirmationDialogOpen={myContractsSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>
  )
}

export default DeleteContract
